






































































































import Modal from "../../core/Modals/Modal.vue";
import moment from "moment";
import { InterventionApi } from "../../api/InterventionApi";
import { DateUtils } from "../../utils/DateUtils";
import { Employe } from "../../models/Employe";
import { TableColumn } from "../../models/UI/TableColumn";
import _ from "lodash";
import { Routes } from "../../utils/Routes";
import ExportButton from "../../core/UI/ExportButton.vue";

export default {
    name: "AbsencesNonAssigneesModal",
    components: { ExportButton, Modal },
    props: {
        showModal: Boolean,
        startDate: String,
        endDate: String,
        filterType: Number,
    },
    data() {
        return {
            heures_absences_unassigned: [],
            days: [],
            InterventionApi: new InterventionApi(),
        };
    },
    computed: {
        typeName(): string {
            return this.filterType === 1 ? "congés" : "absences";
        },
    },
    methods: {
        getHeuresAbsences(): void {
            let self = this;
            self.heures_absences_unassigned = [];
            self.InterventionApi.getAbsencesUnassigned(
                self.startDate,
                self.endDate,
                { type: self.filterType }
            ).then(function (response) {
                self.heures_absences_unassigned = response;
                _.map(self.heures_absences_unassigned, function (heureAbsence) {
                    heureAbsence.employe = new Employe(heureAbsence.employe);
                });
            });
        },
        createDaysList(): void {
            this.days = [];

            let startDate = moment(this.startDate, "YYYY-MM-DD");
            let endDate = moment(this.endDate, "YYYY-MM-DD").add(1, "day");
            while (startDate.isBefore(endDate)) {
                this.days.push(startDate.format("YYYY-MM-DD"));
                startDate.add(1, "days");
            }
        },
        // Callback
        openInterventionList(absencesNonAssignees, day): void {
            let params = {
                start_date: day,
                end_date: day,
                default_sort_id: "dureePrevue",
                default_sort_order: TableColumn.SortOrder.desc,
            };

            if (absencesNonAssignees["heures_absence_unassigned"][day]) {
                let employe = absencesNonAssignees["employe"];

                if (employe) {
                    params["employe_id"] = employe.id;
                    params["employe_nom"] = employe.fullName;
                }

                let searchParams = new URLSearchParams(params);

                window.open(
                    Routes.intervention_list_filter + searchParams.toString(),
                    "_blank"
                );
            }
        },
        getExportParams(): Object {
            return {
                start_date: this.startDate,
                end_date: this.endDate,
                type: this.filterType,
            };
        },
        closeModal(): void {
            this.$emit("close-modal");
        },
        // UI
        dateToStr(date, format: string = "DD/MM/YYYY"): string {
            return DateUtils.sqlToDateStr(date, format);
        },
        displayHeuresNonAssignees(absencesNonAssignees, day): string {
            if (absencesNonAssignees.heures_absence_unassigned[day]) {
                return absencesNonAssignees.heures_absence_unassigned[day];
            }
        },
        totalHeuresNonAssigneesEmploye(absencesNonAssignees): number {
            let res = _.reduce(
                absencesNonAssignees.heures_absence_unassigned,
                function (sum, value) {
                    return sum + value;
                },
                0
            );
            return _.round(res, 2);
        },
        totalHeuresNonAssigneesDay(day): number {
            let res = _.reduce(
                this.heures_absences_unassigned,
                function (sum, absencesNonAssignees) {
                    if (absencesNonAssignees.heures_absence_unassigned[day]) {
                        return (
                            sum +
                            absencesNonAssignees.heures_absence_unassigned[day]
                        );
                    } else {
                        return sum;
                    }
                },
                0
            );
            return _.round(res, 2);
        },
        totalAll(): number {
            let self = this;
            let res = _.reduce(
                this.heures_absences_unassigned,
                function (sum, absencesNonAssignees) {
                    return (
                        sum +
                        self.totalHeuresNonAssigneesEmploye(
                            absencesNonAssignees
                        )
                    );
                },
                0
            );
            return _.round(res, 2);
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function () {
                if (this.showModal) {
                    this.getHeuresAbsences();
                    this.createDaysList();
                }
            },
        },
    },
};
